import React, {useState} from 'react';
import MaterialPageItemModule from "../../../components/UI/modul/MaterialPageItemModule";
import {Breadcrumbs, Typography} from "@mui/material";
import Link from "@mui/material/Link";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import Box from "@mui/material/Box";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";

const AllMaterials = () => {
    const [alertData, setAlertData] = useState({});
    const [pageSize, setPageSize] = useState(10);
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    return <Box sx={{padding: "0 30px"}}>
        <BreadcrumbsComponent page={"Материалы"} path={[{name: "Главная", href: "/"}]}/>
        <MaterialPageItemModule
            allMaterial={true}
            refMaterial={true}
            pageSize={pageSize}
            setPageSize={setPageSize}
            handleModalAlert={handleModalAlert}
        />
        <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
            return {...alert, open: false}
        })}/>
    </Box>
};

export default AllMaterials;